/*
  Sophestia — ortak ana sayfa etkileşimleri.

  Yalnız iki iş yapar: mobil menü çekmecesi ve seçili ürünler bölümündeki
  kategori çipleri (istemci tarafı filtre). Ürün verisi, fiyat ve varyasyon
  mantığı burada yok; onlar Liquid tarafında Shopify verisinden geliyor.
  JavaScript kapalıysa çekmece açık bağlantı listesi, çipler ise pasif kalır
  ve tüm ürünler görünür olur.
*/
(function () {
  'use strict';

  /* Dosya birden çok section tarafından çağrıldığı için aynı kök iki kez
     bağlanabilir; ikinci bağlanmada her tıklama iki kez çalışır ve menü
     hiç açılmaz. Bu yüzden kök bir kez işaretlenir. */
  function claim(root) {
    if (root.getAttribute('data-sph-ready') === '1') return false;
    root.setAttribute('data-sph-ready', '1');
    return true;
  }

  function initHeader(root) {
    if (!claim(root)) return;
    var toggle = root.querySelector('[data-sph="menu-toggle"]');
    var drawer = root.querySelector('[data-sph="menu-drawer"]');
    if (!toggle || !drawer) return;

    drawer.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      drawer.hidden = open;
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (drawer.hidden) return;
      toggle.setAttribute('aria-expanded', 'false');
      drawer.hidden = true;
      toggle.focus();
    });
  }

  function initFilter(root) {
    if (!claim(root)) return;
    var chips = Array.prototype.slice.call(root.querySelectorAll('[data-sph-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-sph-group]'));
    var count = root.querySelector('[data-sph="filter-count"]');
    if (chips.length === 0 || cards.length === 0) return;

    function apply(value) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = value === 'all' || card.getAttribute('data-sph-group') === value;
        card.hidden = !match;
        if (match) shown += 1;
      });
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-sph-filter') === value ? 'true' : 'false');
      });
      if (count) {
        count.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        apply(chip.getAttribute('data-sph-filter'));
      });
    });

    apply('all');
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-sph="header"]')).forEach(initHeader);
    Array.prototype.slice.call(document.querySelectorAll('[data-sph="featured"]')).forEach(initFilter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Tema editöründe bölüm yeniden yüklendiğinde tekrar bağlan.
  document.addEventListener('shopify:section:load', boot);
})();
